import { CONSULTATION_SPECIALTY_KEY, type ConsultationSpecialtyKey } from './specialtyKeys';
import type { PrescriptionPrintTemplateComponent } from './types';
import { BasePrescriptionTemplate } from './templates/BasePrescriptionTemplate';
import { CardiologyPrescriptionTemplate } from './templates/CardiologyPrescriptionTemplate';
import { DermatologyPrescriptionTemplate } from './templates/DermatologyPrescriptionTemplate';
import { GynecologyPrescriptionTemplate } from './templates/GynecologyPrescriptionTemplate';
import { InternalMedicinePrescriptionTemplate } from './templates/InternalMedicinePrescriptionTemplate';
import { OphthalmologyPrescriptionTemplate } from './templates/OphthalmologyPrescriptionTemplate';
import { PediatricsPrescriptionTemplate } from './templates/PediatricsPrescriptionTemplate';
import { TraumatologyPrescriptionTemplate } from './templates/TraumatologyPrescriptionTemplate';

const TEMPLATE_REGISTRY: Partial<Record<ConsultationSpecialtyKey, PrescriptionPrintTemplateComponent>> = {
  [CONSULTATION_SPECIALTY_KEY.PEDIATRICS]: PediatricsPrescriptionTemplate,
  [CONSULTATION_SPECIALTY_KEY.INTERNAL_MEDICINE]: InternalMedicinePrescriptionTemplate,
  [CONSULTATION_SPECIALTY_KEY.TRAUMATOLOGY]: TraumatologyPrescriptionTemplate,
  [CONSULTATION_SPECIALTY_KEY.DERMATOLOGY]: DermatologyPrescriptionTemplate,
  [CONSULTATION_SPECIALTY_KEY.OPHTHALMOLOGY]: OphthalmologyPrescriptionTemplate,
  [CONSULTATION_SPECIALTY_KEY.CARDIOLOGY]: CardiologyPrescriptionTemplate,
  [CONSULTATION_SPECIALTY_KEY.GYNECOLOGY]: GynecologyPrescriptionTemplate,
};

export function getPrescriptionTemplate(
  specialtyKey: ConsultationSpecialtyKey
): PrescriptionPrintTemplateComponent {
  return TEMPLATE_REGISTRY[specialtyKey] ?? BasePrescriptionTemplate;
}
